export function parseRawTranscript(rawSection) {
  try {
    let transcript = rawSection?.title || rawSection;
    if (!transcript) return [];

    // ✅ Case 1: Already an array
    if (Array.isArray(transcript)) {
      return normalizeTranscript(transcript);
    }

    // ✅ Case 2: String input
    if (typeof transcript === "string") {
      let merged = [];

      // Remove prefix if exists
      transcript = transcript.trim().replace(/^rawTranscript:/, "");

      // Try parsing directly
      try {
        const parsed = JSON.parse(transcript);
        if (Array.isArray(parsed)) {
          return normalizeTranscript(parsed);
        }
      } catch (_) {
        // ignore, may be multiple arrays
      }

      // ✅ Case 3: Multiple arrays concatenated
      // Example: `[...] [... ]` or `...], [...]`
      const parts = transcript
        .split(/]\s*,?\s*\[/) // split on "][", "],[" or "], ["
        .map((part, idx, arr) => {
          if (idx > 0) part = "[" + part;
          if (idx < arr.length - 1) part = part + "]";
          return part;
        });

      for (const part of parts) {
        try {
          const parsed = JSON.parse(part);
          if (Array.isArray(parsed)) {
            merged = merged.concat(parsed);
          }
        } catch (_) {
          // ignore broken parts
        }
      }

      return normalizeTranscript(merged);
    }

    return [];
  } catch (err) {
    console.error("Failed to parse transcript:", err);
    return [];
  }
}

// ✅ Normalizer utility
function normalizeTranscript(arr) {
  return arr.map((item) => ({
    speakerLabel: item.speakerLabel || "unknown",
    text: item.text?.trim() || "",
    sessionId: item.sessionId || null,
  }));
}